// These polyfill entry points will be replaced by core-js' target features through Babel
import "core-js/stable";
import "regenerator-runtime/runtime";

import { App, orchestratorInitialiser, createClientApp } from "@flights/webapp-universal";

orchestratorInitialiser();

const i18nState = window.__I18N_STATE__;
if (!i18nState?.locale) throw new Error("localeID not present on window");

const rootNode = document.getElementById("root");
if (!rootNode) throw new Error("No root node provided");

const prefix = process.env.RAZZLE_PREFIX || "";
const globalContext = window.__GLOBAL_CONTEXT__;

try {
  if (window.sessionStorage.debugAllExtraProducts) {
    globalContext.debugAllExtraProducts = true;
  }
} catch {} // eslint-disable-line flights/no-empty-catch

const appPromise = createClientApp({
  rootNode,
  appComponent: App,
  prefix,
  globalContext,
  i18nState
});

if (module.hot) {
  module.hot.accept();
}

export { appPromise as default };
